export default __webpack_public_path__ + "static/small-image-completely-4-4a903ee99bf68bc27c45752d64c064d4.png";